import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Layout } from '../../components/layout';

export const ExceloutArticle: React.FC = () => {
  return (
    <Layout title="INFORMATION" subtitle="お知らせ">
      <Container className="my-5">
        <h1>新製品「excelout」販売開始のお知らせ</h1>
        <p><small>2020-03-14</small></p>
        <p>
          新製品「excelout」を本日2020年3月14日より販売を開始いたします。
        </p>
        <p>
          既に弊社お取引先様での運用実績があり、好評を頂いている製品です。
        </p>
        <p>
          製品の詳細は以下のページをご確認ください。
        </p>
        <ul>
          <li><Link to="/products">product一覧ページ</Link></li>
          <li>exceloutランディングページ</li>
        </ul>
        <p>
          商品のお問い合わせは、弊社お問い合わせフォームよりお問い合わせください。
        </p>
      </Container>
    </Layout>
  );
};
